import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import React, { useCallback, useState } from 'react';


interface IProps {
    onClose: () => void;
}


function RequestSamplesDialog(props: IProps) {
    const { onClose } = props;
    return (
        <Dialog open={true} onClose={onClose} maxWidth="md">
            <DialogTitle>Request access to samples</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Please, fill the following form, and we will contact you as soon as possible.
                </DialogContentText>
                <TextField autoFocus margin="dense" label="Email Address" type="email" fullWidth variant="outlined" />
                <TextField fullWidth multiline autoFocus margin="dense" label="Comment" variant="outlined" />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button color="primary" onClick={onClose}>Request</Button>
            </DialogActions>
        </Dialog>
    );
}


export default RequestSamplesDialog;
